// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__zSEZn","list":"dropdown_list__Tq+-P"};